// view & component
import HomepageRWD from '../view/TitleToolbar/Homepage';
// import ResultTableContentEditPageOne from 'view/AccessManage/M1005/M1005_edit_RWD';
var twmsToolbarRoutes = [
    {
        path: '/homepage',
        sidebarName: null,
        navbarName: null,
        icon: '',
        component: HomepageRWD,
    },
];
export default twmsToolbarRoutes;
